export default __webpack_public_path__ + "static/media/image_hand_1.4779b4c7.png";